import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "Weitere Daten", -1)
const _hoisted_3 = {
  key: 1,
  class: "w-full flex flex-col mt-4"
}
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "w-full flex flex-col bg-zewotherm-lightgrey p-2 rounded-lg mt-2" }
const _hoisted_6 = { class: "w-full mb-2 flex justify-between" }

import AdditionalData from '@/interfaces/additionalData/AdditionalData'
import AdditionalDataField from '@/interfaces/additionalData/AdditionalDataField'
import { useSelectedProject } from '@/store/selectedProject'
import { useType } from '@/store/type'
import { computed } from '@vue/reactivity'
import { ComputedRef } from 'vue'
import LabelAndValueDiv from '@/components/DetailPage/LabelAndValueDiv.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalData',
  setup(__props) {

const selectedProjectStore = useSelectedProject()
const typeStore = useType()

const additionalDataType: ComputedRef<AdditionalData> = computed(() => {
  const foundType = typeStore.projectTypes.find(projectType => {
    return projectType.value === selectedProjectStore.project.type
  })

  if(!foundType) return {} as AdditionalData

  const foundAdditionalData = typeStore.additionalDataTypes.find(additionalDataType => {
    return additionalDataType.label === foundType.titel
  })

  if(!foundAdditionalData) return {} as AdditionalData
  return foundAdditionalData
})

function getValueWithAddtitionalDataField(additionalDataField: AdditionalDataField, value: any) {
  if(additionalDataField.type === 'date') {
    return returnLocaleDate(value.toString())
  } else if (additionalDataField.type === 'select') {
    return additionalDataField.options?.find(option => value.toString() == option.value)!.label
  } else if (additionalDataField.type === 'checkbox') {
    return value === true ? 'Ja' : 'Nein'
  } else {
    return value.toString()
  }
}

function returnLocaleDate(date: string | Date) {
  if(date == null) {
    return ""
  }
  return new Date(date).toLocaleDateString()
}

return (_ctx: any,_cache: any) => {
  return (_unref(selectedProjectStore).project.additional_fields)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(additionalDataType).fields, (additionalDataField) => {
          return (_openBlock(), _createElementBlock("div", {
            key: additionalDataField.id
          }, [
            (_unref(selectedProjectStore).project.additional_fields[additionalDataField.name] && _unref(selectedProjectStore).project.additional_fields[additionalDataField.name] !== null && additionalDataField.type !== 'array')
              ? (_openBlock(), _createBlock(LabelAndValueDiv, {
                  key: 0,
                  label: additionalDataField.label,
                  value: additionalDataField.prefix + getValueWithAddtitionalDataField(additionalDataField, _unref(selectedProjectStore).project.additional_fields[additionalDataField.name]) + additionalDataField.suffix
                }, null, 8, ["label", "value"]))
              : (_unref(selectedProjectStore).project.additional_fields[additionalDataField.name] && _unref(selectedProjectStore).project.additional_fields[additionalDataField.name].length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("label", _hoisted_4, _toDisplayString(additionalDataField.label), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalDataField.arrayDefinition, (field) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: field.id,
                            class: "flex-grow w-0 text-center font-semibold"
                          }, _toDisplayString(field.shortLabel ? field.shortLabel : field.label), 1))
                        }), 128))
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedProjectStore).project.additional_fields[additionalDataField.name], (arrayData, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "w-full flex mt-2 justify-between",
                          key: arrayData._id
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalDataField.arrayDefinition, (field) => {
                            return (_openBlock(), _createElementBlock("label", {
                              class: "flex-grow w-0 text-center",
                              key: field.id
                            }, [
                              _createElementVNode("span", null, _toDisplayString(field.prefix), 1),
                              _createTextVNode(" " + _toDisplayString(_unref(selectedProjectStore).project.additional_fields[additionalDataField.name][index][field.name] ? getValueWithAddtitionalDataField(field, _unref(selectedProjectStore).project.additional_fields[additionalDataField.name][index][field.name]) : '') + " ", 1),
                              _createElementVNode("span", null, _toDisplayString(field.suffix), 1)
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})